import React, { forwardRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentCheckmarkFilled = forwardRef<Svg, { fillColor?: string } & SvgProps>(
  (
    { fillColor = '#212121', ...props }: { fillColor?: string } & SvgProps,
    ref
  ) => (
    <Svg
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      ref={ref}
      {...props}
    >
      <Path
        d='M8.5 16.586l-3.793-3.793a1 1 0 00-1.414 1.414l4.5 4.5a1 1 0 001.414 0l11-11a1 1 0 00-1.414-1.414L8.5 16.586z'
        fill={fillColor}
      />
    </Svg>
  )
)

export default FluentCheckmarkFilled
